// @disable eslint-plugin/prettier/prettier */
export const formatRoleName = (role: string): string =>
  role
    .replace(/_/g, " ") // Replace underscores with spaces
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
